<template>
  <div class="g-wrapper g-vertical-block">
    <div class="g-main-wrapper g-vertical-block main-content">
      <Row :gutter="12">
        <Col span="24">
          <Tabs :value="currentRoute" @on-click="changeRouter">
            <TabPane name="minigamecomplex" label="小游戏综合报表"></TabPane>
          </Tabs>
        </Col>
      </Row>
      <div class="c-content">
        <keep-alive :max="10">
          <router-view />
        </keep-alive>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'comprehensionminigamereport',
  data() {
    return {
      currentRoute: ''
    }
  },
  methods: {
    changeRouter(name) {
      this.$router.push({ name })
    },
    getCurrent() {
      this.currentRoute = this.$route.name
      if (this.$route.name === 'comprehensionminigamereport') this.changeRouter('minigamecomplex')
    }
  },
  watch: {
    $route: {
      handler() {
        this.getCurrent()
      },
      deep: true
    }
  },
  created() {
    this.getCurrent()
  }
}
</script>
<style lang="scss" scoped>
.c-content {
  position: relative;
}
</style>
